/** Set to true to restore online free-account registration. */
export const FREE_SIGNUP_ENABLED = false;
